import { useEffect, useState } from "react";
import Pagination from "../../../components/Pagination";
import SortedHeader from "../../../components/Tables/SortedHeader";
import { TechnologyCategoryService } from "../../../services/TechnologyCategoryService";
import { technologyService } from "../../../services/TechnologyService";
import { TechnologySubCategoryService } from "../../../services/TechnologySubCategory";
import { ReactComponent as IconPlus } from "../../../layout/others/icon_plus.svg";
import ModalContainer from "../../../containers/Modal/ModalContainer";
import IconEdit from "../../../layout/others/icon_edit.svg";
import IconDelete from "../../../layout/others/icon_delete.svg";
import { useTranslation } from "react-i18next";
import { useInterviewSettingsContext } from "../interviewSettingsContext";
import { CreateOrEdit } from "./CreateOrEdit";
import { useGeneralContext } from "../../General/Context";
import { toast } from "react-toastify";

export default function SkillPage(props) {
  const [searchObject, setSearchObject] = useState({});
  const [categories, setCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [skills, setSkills] = useState([]);
  const [pageNumber, setPageNumber] = useState(1);
  const [totalPages, setTotalPages] = useState(0);
  const [skillId, setSkillId] = useState();
  const [openDelete, setOpenDelete] = useState(false);
  const [skillForDelete, steSkillForDelete] = useState();
  const {
    newCategoryAdded,
    setNewCategoryAdded,
    newSubcategoryAdded,
    setNewSubCategoryAdded
  } = useInterviewSettingsContext();
  const { userInformation } = useGeneralContext();
  const [isopen, setIsOpen] = useState();
  const { t } = useTranslation();
  const PAGE_SIZE = 20;

  useEffect(() => {
    getTechnologies();
  }, [searchObject, pageNumber]);

  useEffect(() => {
    TechnologySubCategoryService.GetAll().then((data) => {
      setSubCategories(data);
      setNewSubCategoryAdded(false);
    });
  }, [newSubcategoryAdded]);

  useEffect(() => {
    TechnologyCategoryService.getAll().then((data) => {
      setCategories(data);
      setNewCategoryAdded(false);
    });
  }, [newCategoryAdded]);

  const [headers, setHeaders] = useState([
    { label: t("Skill Name"), field: "Description" },

    { label: "" }
  ]);

  function onChange({ target }) {
    setSearchObject({ ...searchObject, [target.name]: target.value });
  }

  function editSkill(id) {
    setSkillId(id);
    setIsOpen(true);
  }

  function closeCreateOrEdit() {
    setIsOpen(false);
    setSkillId(null);
  }

  function getTechnologies() {
    technologyService
      .getTechnologies(PAGE_SIZE, pageNumber, searchObject)
      .then((data) => {
        setSkills(data.page);
        setTotalPages(Math.ceil(data.total / PAGE_SIZE));
      });
  }

  function openForDelete(skillId) {
    setOpenDelete(true);
    steSkillForDelete(skillId);
  }

  function closeDelete() {
    steSkillForDelete();
    setOpenDelete(false);
  }

  function deleteTechnology() {
    technologyService.deleteTechnology(skillForDelete).then((data) => {
      if (!data) {
        steSkillForDelete();
        setOpenDelete(false);
        getTechnologies();
      }
    });
    toast.success(t("Successfully Delete"));
  }

  function openCreateOrEdit() {
    setIsOpen(true);
  }

  return (
    <>
      <div className="row">
        <div className="col-sm">
          <ul className="list-inline mt-2">
            <li className="list-inline-item">
              <div className="form-group">
                <input
                  placeholder={t("Skill Name")}
                  className="form-control"
                  type="text"
                  value={searchObject.name}
                  onChange={onChange}
                  name="name"
                />
              </div>
            </li>
          </ul>
        </div>

        <div className="col-sm text-end">
          <div>
            <button
              className="app-button btn-prime btn-md"
              onClick={() => openCreateOrEdit()}
            >
              <IconPlus /> {t("Add")}
            </button>
          </div>
        </div>
      </div>

      <div className="table-wrap quiz-management">
        <table>
          <thead>
            <SortedHeader
              searchObject={searchObject}
              setSearchObject={setSearchObject}
              headers={headers}
              setHeaders={setHeaders}
            />
          </thead>
          <tbody>
            {skills.map((skill) => (
              <tr>
                <td className="skill-name text-truncate">
                  {t(skill.description)}
                </td>

                <td className="actions">
                  {userInformation.permissions
                    .InterviewSettings_Create_Edit_Skill && (
                    <button
                      onClick={() => editSkill(skill.id)}
                      className="action-button-settings"
                      type="button"
                    >
                      <img
                        src={IconEdit}
                        alt={t("Edit")}
                        height="12px"
                        width="auto"
                      />
                    </button>
                  )}

                  <button
                    onClick={() => openForDelete(skill.id)}
                    className="action-button-settings"
                    type="button"
                  >
                    <img
                      src={IconDelete}
                      alt={t("Delete")}
                      height="12px"
                      width="auto"
                    />
                  </button>
                </td>
              </tr>
            ))}
            {skills.length === 0 && (
              <div className="table-message">{t("No Skills found.")}</div>
            )}
          </tbody>
        </table>
      </div>
      <div className="row">
        <div className="text-end">
          <Pagination
            totalPages={totalPages}
            setPageNumber={setPageNumber}
            pageNumber={pageNumber}
          />
        </div>
        <CreateOrEdit
          open={isopen}
          close={closeCreateOrEdit}
          categories={categories}
          subCategories={subCategories}
          skillId={skillId}
          refresh={getTechnologies}
          skills={skills}
        />
      </div>
      <ModalContainer
        modalTitle={t("Delete")}
        isOpen={openDelete}
        closeModal={closeDelete}
        submitButtonAction={deleteTechnology}
        cancelButtonTitle={t("Cancel")}
        cancelButtonAction={closeDelete}
        submitButtonTitle={t("Delete")}
        submitButtonType="button"
      >
        {t("Are you sure you want to delete ?")}
      </ModalContainer>
    </>
  );
}
